import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { CartContext } from '../../contexts/CartContext';

import { CreditCard } from './creditcard.component';
import { Loading } from './loading.component';
import { AddModalProps } from './payment-method.component';

export const AddCreditCard = ({
    openAddModal,
    setAddModalIsOpen,
    setOpenParentModal,
    setCheckoutStep,
}: AddModalProps) => {
    const { t } = useTranslation();
    const { setSubmitCreditCard, submitCreditCard } = useContext(CartContext);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const closeModal = () => {
        setAddModalIsOpen(false);
        setOpenParentModal(true);
    };

    const addCartCreditCard = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setSubmitCreditCard('add');
    };

    React.useEffect(() => {
        if (!openAddModal) {
            setIsSubmitting(false);
        }
    }, [openAddModal]);

    // Reset button when submission completes (success or failure)
    React.useEffect(() => {
        if (submitCreditCard === 'none') {
            setIsSubmitting(false);
        }
    }, [submitCreditCard]);

    Modal.setAppElement('#expressCheckout');

    return (
        <>
            <Modal
                isOpen={openAddModal}
                contentLabel="Use A New Card"
                className="modal__contentwrap"
                overlayClassName="modal__overlay"
            >
                <div className="modal__header">
                    <button className="modal__button-back" onClick={closeModal}>
                        {t('Back')}
                    </button>
                    <h3 className="cc__modal-text">{t('Use A New Card')}</h3>
                    <button className="modal__button-close" onClick={closeModal}>
                        {t('Close')}
                    </button>
                </div>
                <div className="modal__body">
                    <CreditCard
                        setCheckoutStep={setCheckoutStep}
                        setAddModalIsOpen={setAddModalIsOpen}
                        selectedCreditCard={null}
                        setEditModalIsOpen={null}
                        setOpenParentModal={null}
                        showPayPal={false}
                    />
                </div>
                <div className="modal__footer">
                    <Loading />
                    <button className="modal__button--save button" onClick={addCartCreditCard} disabled={isSubmitting}>
                        {t('Save & Continue')}
                    </button>
                </div>
            </Modal>
        </>
    );
};
